(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3256,2576],{

/***/ 21973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customer_data_maturity_evaluation; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/Hero/Hero.tsx




var copy = {
  heading: "Customer Data Maturity Evaluation"
};

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroComponent, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          centered: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h1",
            children: copy.heading
          })
        })
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e9gq8t21"
} : 0)( true ? "" : 0);

var HeroComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e9gq8t20"
} : 0)(recipes_Hero/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/components/Radio/index.ts + 2 modules
var Radio = __webpack_require__(29418);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/Quiz/data.ts
var data = [{
  key: "collect",
  question: "How widely and reliably do you COLLECT your customer data?",
  answers: {
    a: {
      title: "We collect data from a few sources but collection methods are inconsistent\u2014different sources have unrelated tracking plans.",
      score: 0
    },
    b: {
      title: "We collect data from a majority of sources but collection methods are inconsistent\u2014different sources have unrelated tracking plans.",
      score: 1
    },
    c: {
      title: "We collect data from a few sources, and some of my collection methods are consistent\u2014some sources share a common tracking plan.",
      score: 1
    },
    d: {
      title: "We collect data from a majority of our data sources, and most collection methods are consistent\u2014the majority of our sources share a common schema.",
      score: 2
    },
    e: {
      title: "We collect data from all sources, and all collection methods are consistent and enforced across a common schema.",
      score: 3
    },
    f: {
      title: "Not sure",
      score: 0
    }
  }
}, {
  key: "synthesize",
  question: "How consistently do you SYNTHESIZE your customer data into customer profiles and actionable insights?",
  answers: {
    a: {
      title: "None of my data is synthesized into a single customer view or actionable insights.",
      score: 0
    },
    b: {
      title: "Some of my data sources drive a partially unified customer view with limited insights.",
      score: 1
    },
    c: {
      title: "Most of my data sources drive a nearly comprehensive customer view that we use to drive actionable insights.",
      score: 2
    },
    d: {
      title: "All of my online and offline data sources are unified into a comprehensive customer view that we use to drive actionable insights.\n",
      score: 3
    },
    e: {
      title: "Not sure",
      score: 0
    }
  }
}, {
  key: "act",
  question: "How able are you to ACT on your customer data?",
  answers: {
    a: {
      title: "I\u2019m unable to take action on my customer data.",
      score: 0
    },
    b: {
      title: "I can take basic action on my data, like simple email and in-app message campaigns.",
      score: 1
    },
    c: {
      title: "I take sophisticated action on my customer data, including segmented, targeted communications, and retargeting campaigns.",
      score: 2
    },
    d: {
      title: "I take advanced action on my customer data by leveraging propensity scores and other predictive models.",
      score: 3
    },
    e: {
      title: "Not sure",
      score: 0
    }
  }
}, {
  key: "adapt",
  question: "How quickly can you ADAPT with your customer data?",
  answers: {
    a: {
      title: "I can\u2019t connect new platforms, tools, or user dimensions to my existing data.",
      score: 0
    },
    b: {
      title: "It takes substantial effort to connect my customer data to new tools, platforms, and user dimensions/events.",
      score: 1
    },
    c: {
      title: "I can easily activate new tools, platforms, and user dimensions/events to my customer data.",
      score: 2
    },
    d: {
      title: "I proactively, strategically, and continuously test and activate new tools, platforms, and user dimensions/events to my customer data.",
      score: 3
    },
    e: {
      title: "Not sure",
      score: 0
    }
  }
}];
/* harmony default export */ var Quiz_data = (data);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/Quiz/Quiz.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Quiz = function Quiz(_ref) {
  var form = _ref.form;
  var register = form.register;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: Quiz_data.map(function (item, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(QuestionItem, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Overline */.Lh, {
              children: ["Question ", index + 1, " of ", Quiz_data.length]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              variant: "h4",
              tag: "h2",
              children: item.question
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Answers, {
            children: Object.entries(item.answers).map(function (_ref2) {
              var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
                  key = _ref3[0],
                  title = _ref3[1].title;

              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Radio/* default */.Z, _objectSpread({
                label: title,
                value: key
              }, register("answers.".concat(index))), title);
            })
          }), index + 1 < Quiz_data.length ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}) : null]
        }, index);
      })
    })
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e5rr0dg2"
} : 0)(Section/* Wrapper */.im, "{padding-top:0px;padding-bottom:0;gap:0;}" + ( true ? "" : 0));

var QuestionItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e5rr0dg1"
} : 0)("margin-bottom:60px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.down("md");
}, "{margin-bottom:30px;}" + ( true ? "" : 0));

var Answers = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e5rr0dg0"
} : 0)("margin-top:30px;margin-bottom:60px;text-align:left;display:grid;gap:20px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down("md");
}, "{margin-bottom:30px;}" + ( true ? "" : 0));

/* harmony default export */ var Quiz_Quiz = (Quiz);
// EXTERNAL MODULE: ../../libs/templates/Forms/EmailCaptureForm/index.ts + 3 modules
var EmailCaptureForm = __webpack_require__(41948);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/calculateResults.ts

var formatTrackingResults = function formatTrackingResults(raw) {
  var act = raw.act,
      adapt = raw.adapt,
      collect = raw.collect,
      synthesize = raw.synthesize,
      total = raw.total,
      rating = raw.rating;
  return {
    actResponse: act.response,
    actScore: act.score,
    adaptResponse: adapt.response,
    adaptScore: adapt.score,
    cdmRating: rating,
    collectResponse: collect.response,
    collectScore: collect.score,
    synthesizeResponse: synthesize.response,
    synthesizeScore: synthesize.score,
    totalScore: total
  };
};

var calculateResults = function calculateResults(answers) {
  var defaults = {
    act: {
      score: 0
    },
    adapt: {
      score: 0
    },
    collect: {
      score: 0
    },
    synthesize: {
      score: 0
    },
    total: 0,
    rating: ""
  };
  var result = Quiz_data.reduce(function (acc, type, index) {
    var response = type.answers[answers[index]];
    acc["".concat(type.key)].score = (response === null || response === void 0 ? void 0 : response.score) || 0;
    acc["".concat(type.key)].response = (response === null || response === void 0 ? void 0 : response.title) || "";
    acc.total += (response === null || response === void 0 ? void 0 : response.score) || 0;
    return acc;
  }, defaults);

  if (result.total <= 3) {
    result.rating = "getting-started";
  } else if (result.total <= 7) {
    result.rating = "developing";
  } else if (result.total <= 11) {
    result.rating = "leading";
  } else if (result.total > 11) {
    result.rating = "visionary";
  }

  return result;
};

/* harmony default export */ var CustomerDataMaturityEvaluation_calculateResults = (calculateResults);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/CalculateResults/CalculateResults.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var CalculateResults_copy = {
  heading: "Calculate your results",
  description: "Enter your email so we can send your results. We\u2019ll show you the results right away and send you the copy.",
  button: "Send results"
};

var CalculateResults = function CalculateResults(_ref) {
  var _onSubmit = _ref.onSubmit,
      answers = _ref.answers;
  var result = (0,react.useMemo)(function () {
    return CustomerDataMaturityEvaluation_calculateResults(answers);
  }, [answers]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CalculateResults_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CalculateResults_StyledSection, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: CalculateResults_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: CalculateResults_copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailCaptureForm/* default */.Z, {
            compact: true,
            buttonText: CalculateResults_copy.button,
            success: null,
            onSubmit: function onSubmit() {
              return _onSubmit(result);
            },
            customFormIdentifier: "cdm-quiz",
            customData: {
              customTrackData: formatTrackingResults(result)
            }
          })
        })]
      })
    })
  });
};

var CalculateResults_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11914363"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var CalculateResults_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e11914362"
} : 0)(Section/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e11914361"
} : 0)( true ? {
  name: "114rxkh",
  styles: "max-width:680px"
} : 0);

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11914360"
} : 0)( true ? {
  name: "ps7kis",
  styles: "max-width:420px;margin:30px 0"
} : 0);

/* harmony default export */ var CalculateResults_CalculateResults = (CalculateResults);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/OverallResult/Svg/GettingStarted.tsx





var GettingStarted_GettingStarted = function GettingStarted(_ref) {
  var active = _ref.active;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      opacity: active ? 1 : 0.7,
      d: "M2.22728 294C1.54947 294 1 293.451 1 292.773C1 292.297 1.2749 291.864 1.70547 291.662L138.599 227.356C143.904 224.864 150 228.735 150 234.597V286C150 290.418 146.418 294 142 294H2.22728Z",
      fill: active ? "url(#getting-started-gradient)" : colors.defaultColumnFill
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fill: active ? colors.activeTextColor : colors.defaultTextColor,
      d: "M18.795 339.162c3.294 0 5.58-1.98 5.58-5.706v-.954h-5.292v1.296h3.762c-.054 2.286-1.26 4.104-4.05 4.104-3.024 0-4.608-2.088-4.608-5.274v-.144c0-3.15 1.692-5.31 4.644-5.31 1.872 0 3.276.792 3.636 2.844h1.566c-.396-2.898-2.682-4.086-5.238-4.086-3.69 0-6.228 2.808-6.228 6.57v.144c0 3.762 2.268 6.516 6.228 6.516Zm11.945 0c2.124 0 3.69-.99 4.014-2.88H33.26c-.198 1.098-1.044 1.638-2.502 1.638-1.926 0-2.952-1.188-3.024-3.33h7.092v-.486c0-3.366-2.052-4.68-4.23-4.68-2.592 0-4.41 1.98-4.41 4.824v.144c0 2.898 1.89 4.77 4.554 4.77Zm-2.952-5.778c.252-1.674 1.278-2.718 2.808-2.718 1.548 0 2.556.774 2.7 2.718h-5.508Zm12.192 5.742c.612 0 .972-.09 1.278-.198v-1.26a3.075 3.075 0 0 1-1.152.198c-.756 0-1.17-.45-1.17-1.368v-5.652h2.196v-1.26h-2.196v-2.142h-1.494v2.142h-1.35v1.26h1.35v5.796c0 1.476.828 2.484 2.538 2.484Zm6.399 0c.612 0 .972-.09 1.278-.198v-1.26a3.075 3.075 0 0 1-1.152.198c-.756 0-1.17-.45-1.17-1.368v-5.652h2.196v-1.26h-2.196v-2.142H43.84v2.142h-1.35v1.26h1.35v5.796c0 1.476.828 2.484 2.538 2.484ZM49.95 339h1.494v-9.414h-1.494V339Zm.72-11.376c.54 0 .99-.45.99-.99s-.45-.99-.99-.99-.99.45-.99.99.45.99.99.99ZM54.503 339h1.494v-5.706c0-1.692 1.242-2.574 2.628-2.574 1.512 0 2.214.738 2.214 2.394V339h1.494v-5.778c0-2.736-1.368-3.798-3.312-3.798-1.548 0-2.592.774-3.024 1.656v-1.494h-1.494V339Zm14.52 3.438c2.628 0 4.482-1.332 4.5-4.068v-8.784h-1.494v1.512c-.54-.918-1.512-1.674-3.078-1.674-2.592 0-4.392 2.124-4.392 4.68v.126c0 2.592 1.818 4.464 4.284 4.464 1.368 0 2.646-.864 3.186-1.782v1.368c0 2.016-1.17 2.898-3.024 2.898-1.602 0-2.502-.558-2.718-1.638h-1.53c.252 1.584 1.476 2.898 4.266 2.898Zm-.018-4.986c-1.584 0-2.898-1.224-2.898-3.276v-.144c0-1.98 1.116-3.366 2.988-3.366 1.836 0 2.988 1.224 2.988 3.33v.126c0 2.106-1.332 3.33-3.078 3.33Zm15.22 1.71c2.287 0 3.457-1.152 3.457-2.862 0-1.998-1.368-2.43-3.312-2.79-1.728-.306-2.196-.648-2.196-1.494 0-.81.702-1.35 1.782-1.35 1.188 0 1.764.45 1.98 1.476h1.44c-.252-2.034-1.71-2.718-3.402-2.718-1.476 0-3.186.9-3.186 2.646 0 1.638.828 2.322 3.276 2.772 1.458.27 2.196.594 2.196 1.584 0 1.008-.63 1.494-2.052 1.494-1.512 0-2.106-.702-2.214-1.818h-1.458c.09 1.926 1.44 3.06 3.69 3.06Zm8.595-.036c.612 0 .972-.09 1.278-.198v-1.26a3.075 3.075 0 0 1-1.152.198c-.756 0-1.17-.45-1.17-1.368v-5.652h2.196v-1.26h-2.196v-2.142h-1.494v2.142h-1.35v1.26h1.35v5.796c0 1.476.828 2.484 2.538 2.484Zm5.983.036c1.386 0 2.232-.468 2.934-1.35V339h1.494v-6.21c0-2.628-1.638-3.366-3.438-3.366-1.818 0-3.528.792-3.726 2.934h1.494c.144-1.152.864-1.692 2.16-1.692 1.44 0 2.016.63 2.016 2.124v.684h-1.35c-2.412 0-4.716.738-4.716 2.916 0 1.926 1.386 2.772 3.132 2.772Zm.144-1.188c-1.314 0-1.782-.612-1.782-1.584 0-1.386 1.386-1.854 3.276-1.854h1.296v1.17c0 1.458-1.206 2.268-2.79 2.268Zm7.218 1.026h1.494v-5.166c0-2.322 1.206-2.916 3.096-3.006v-1.404c-1.692.054-2.502.792-3.096 1.854v-1.692h-1.494V339Zm9.718.126c.612 0 .972-.09 1.278-.198v-1.26a3.075 3.075 0 0 1-1.152.198c-.756 0-1.17-.45-1.17-1.368v-5.652h2.196v-1.26h-2.196v-2.142h-1.494v2.142h-1.35v1.26h1.35v5.796c0 1.476.828 2.484 2.538 2.484Zm7.388.036c2.124 0 3.69-.99 4.014-2.88h-1.494c-.198 1.098-1.044 1.638-2.502 1.638-1.926 0-2.952-1.188-3.024-3.33h7.092v-.486c0-3.366-2.052-4.68-4.23-4.68-2.592 0-4.41 1.98-4.41 4.824v.144c0 2.898 1.89 4.77 4.554 4.77Zm-2.952-5.778c.252-1.674 1.278-2.718 2.808-2.718 1.548 0 2.556.774 2.7 2.718h-5.508Zm12.877 5.778c1.368 0 2.682-.864 3.222-1.782V339h1.494v-13.914h-1.494v6.012c-.54-.918-1.512-1.674-3.078-1.674-2.592 0-4.392 2.034-4.392 4.914v.144c0 2.934 1.782 4.68 4.248 4.68Zm.162-1.242c-1.584 0-2.862-1.134-2.862-3.51v-.144c0-2.286 1.116-3.6 2.988-3.6 1.836 0 2.988 1.134 2.988 3.546v.144c0 2.412-1.368 3.564-3.114 3.564Z"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
        id: "getting-started-gradient",
        x1: "75.5001",
        y1: "222",
        x2: "75.5001",
        y2: "294",
        gradientUnits: "userSpaceOnUse",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          stopColor: "#EFEFEF"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "1",
          stopColor: "#D1CFD4"
        })]
      })
    })]
  });
};

/* harmony default export */ var Svg_GettingStarted = (GettingStarted_GettingStarted);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/OverallResult/Svg/Developing.tsx





var Developing = function Developing(_ref) {
  var active = _ref.active;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      opacity: active ? 1 : 0.7,
      d: "M162 223.038C162 219.959 163.767 217.153 166.543 215.823L294.543 154.49C299.853 151.945 306 155.816 306 161.704V286C306 290.418 302.418 294 298 294H170C165.582 294 162 290.418 162 286V223.038Z",
      fill: active ? "url(#developing-gradient)" : colors.defaultColumnFill
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M189.365 337.722V327.39H191.111C194.657 327.39 196.097 329.478 196.097 332.448V332.592C196.097 335.742 194.441 337.722 191.129 337.722H189.365ZM187.799 339H191.165C195.665 339 197.717 336.174 197.717 332.61V332.448C197.717 328.866 195.629 326.13 191.201 326.13H187.799V339ZM204.076 339.162C206.2 339.162 207.766 338.172 208.09 336.282H206.596C206.398 337.38 205.552 337.92 204.094 337.92C202.168 337.92 201.142 336.732 201.07 334.59H208.162V334.104C208.162 330.738 206.11 329.424 203.932 329.424C201.34 329.424 199.522 331.404 199.522 334.248V334.392C199.522 337.29 201.412 339.162 204.076 339.162ZM201.124 333.384C201.376 331.71 202.402 330.666 203.932 330.666C205.48 330.666 206.488 331.44 206.632 333.384H201.124ZM212.724 339H214.632L218.016 329.586H216.468L213.714 337.488L210.924 329.586H209.304L212.724 339ZM223.57 339.162C225.694 339.162 227.26 338.172 227.584 336.282H226.09C225.892 337.38 225.046 337.92 223.588 337.92C221.662 337.92 220.636 336.732 220.564 334.59H227.656V334.104C227.656 330.738 225.604 329.424 223.426 329.424C220.834 329.424 219.016 331.404 219.016 334.248V334.392C219.016 337.29 220.906 339.162 223.57 339.162ZM220.618 333.384C220.87 331.71 221.896 330.666 223.426 330.666C224.974 330.666 225.982 331.44 226.126 333.384H220.618ZM229.985 339H231.497V325.086H229.985V339ZM238.478 337.92C236.57 337.92 235.4 336.516 235.4 334.374V334.23C235.4 332.07 236.588 330.666 238.478 330.666C240.35 330.666 241.556 332.07 241.556 334.248V334.374C241.556 336.498 240.368 337.92 238.478 337.92ZM238.46 339.162C241.142 339.162 243.104 337.2 243.104 334.356V334.212C243.104 331.386 241.142 329.424 238.478 329.424C235.814 329.424 233.852 331.404 233.852 334.23V334.374C233.852 337.128 235.778 339.162 238.46 339.162ZM245.417 342.276H246.911V337.452C247.451 338.388 248.549 339.162 250.097 339.162C252.689 339.162 254.381 337.182 254.381 334.302V334.158C254.381 331.224 252.563 329.424 250.097 329.424C248.729 329.424 247.451 330.252 246.911 331.17V329.586H245.417V342.276ZM249.953 337.92C248.117 337.92 246.857 336.786 246.857 334.374V334.23C246.857 331.818 248.189 330.666 249.935 330.666C251.519 330.666 252.833 331.854 252.833 334.23V334.374C252.833 336.66 251.825 337.92 249.953 337.92ZM256.738 339H258.232V329.586H256.738V339ZM257.458 327.624C257.998 327.624 258.448 327.174 258.448 326.634C258.448 326.094 257.998 325.644 257.458 325.644C256.918 325.644 256.468 326.094 256.468 326.634C256.468 327.174 256.918 327.624 257.458 327.624ZM261.29 339H262.784V333.294C262.784 331.602 264.026 330.72 265.412 330.72C266.924 330.72 267.626 331.458 267.626 333.114V339H269.12V333.222C269.12 330.486 267.752 329.424 265.808 329.424C264.26 329.424 263.216 330.198 262.784 331.08V329.586H261.29V339ZM275.81 342.438C278.438 342.438 280.292 341.106 280.31 338.37V329.586H278.816V331.098C278.276 330.18 277.304 329.424 275.738 329.424C273.146 329.424 271.346 331.548 271.346 334.104V334.23C271.346 336.822 273.164 338.694 275.63 338.694C276.998 338.694 278.276 337.83 278.816 336.912V338.28C278.816 340.296 277.646 341.178 275.792 341.178C274.19 341.178 273.29 340.62 273.074 339.54H271.544C271.796 341.124 273.02 342.438 275.81 342.438ZM275.792 337.452C274.208 337.452 272.894 336.228 272.894 334.176V334.032C272.894 332.052 274.01 330.666 275.882 330.666C277.718 330.666 278.87 331.89 278.87 333.996V334.122C278.87 336.228 277.538 337.452 275.792 337.452Z",
      fill: active ? colors.activeTextColor : colors.defaultTextColor
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
        id: "developing-gradient",
        x1: "234",
        y1: "113.745",
        x2: "234",
        y2: "293.5",
        gradientUnits: "userSpaceOnUse",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          stopColor: "#FF9393"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "1",
          stopColor: "#DD1B00"
        })]
      })
    })]
  });
};

/* harmony default export */ var Svg_Developing = (Developing);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/OverallResult/Svg/Leading.tsx





var Leading = function Leading(_ref) {
  var active = _ref.active;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      opacity: active ? 1 : 0.7,
      d: "M318 149.038C318 145.959 319.767 143.153 322.543 141.823L450.543 80.4898C455.853 77.9453 462 81.8159 462 87.7043V286C462 290.418 458.418 294 454 294H326C321.582 294 318 290.418 318 286V149.038Z",
      fill: active ? "url(#leading-gradient)" : colors.defaultColumnFill
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M357.914 339H365.366V337.722H359.48V326.13H357.914V339ZM371.115 339.162C373.239 339.162 374.805 338.172 375.129 336.282H373.635C373.437 337.38 372.591 337.92 371.133 337.92C369.207 337.92 368.181 336.732 368.109 334.59H375.201V334.104C375.201 330.738 373.149 329.424 370.971 329.424C368.379 329.424 366.561 331.404 366.561 334.248V334.392C366.561 337.29 368.451 339.162 371.115 339.162ZM368.163 333.384C368.415 331.71 369.441 330.666 370.971 330.666C372.519 330.666 373.527 331.44 373.671 333.384H368.163ZM379.939 339.162C381.325 339.162 382.171 338.694 382.873 337.812V339H384.367V332.79C384.367 330.162 382.729 329.424 380.929 329.424C379.111 329.424 377.401 330.216 377.203 332.358H378.697C378.841 331.206 379.561 330.666 380.857 330.666C382.297 330.666 382.873 331.296 382.873 332.79V333.474H381.523C379.111 333.474 376.807 334.212 376.807 336.39C376.807 338.316 378.193 339.162 379.939 339.162ZM380.083 337.974C378.769 337.974 378.301 337.362 378.301 336.39C378.301 335.004 379.687 334.536 381.577 334.536H382.873V335.706C382.873 337.164 381.667 337.974 380.083 337.974ZM390.848 339.162C392.216 339.162 393.53 338.298 394.07 337.38V339H395.564V325.086H394.07V331.098C393.53 330.18 392.558 329.424 390.992 329.424C388.4 329.424 386.6 331.458 386.6 334.338V334.482C386.6 337.416 388.382 339.162 390.848 339.162ZM391.01 337.92C389.426 337.92 388.148 336.786 388.148 334.41V334.266C388.148 331.98 389.264 330.666 391.136 330.666C392.972 330.666 394.124 331.8 394.124 334.212V334.356C394.124 336.768 392.756 337.92 391.01 337.92ZM398.623 339H400.117V329.586H398.623V339ZM399.343 327.624C399.883 327.624 400.333 327.174 400.333 326.634C400.333 326.094 399.883 325.644 399.343 325.644C398.803 325.644 398.353 326.094 398.353 326.634C398.353 327.174 398.803 327.624 399.343 327.624ZM403.175 339H404.669V333.294C404.669 331.602 405.911 330.72 407.297 330.72C408.809 330.72 409.511 331.458 409.511 333.114V339H411.005V333.222C411.005 330.486 409.637 329.424 407.693 329.424C406.145 329.424 405.101 330.198 404.669 331.08V329.586H403.175V339ZM417.695 342.438C420.323 342.438 422.177 341.106 422.195 338.37V329.586H420.701V331.098C420.161 330.18 419.189 329.424 417.623 329.424C415.031 329.424 413.231 331.548 413.231 334.104V334.23C413.231 336.822 415.049 338.694 417.515 338.694C418.883 338.694 420.161 337.83 420.701 336.912V338.28C420.701 340.296 419.531 341.178 417.677 341.178C416.075 341.178 415.175 340.62 414.959 339.54H413.429C413.681 341.124 414.905 342.438 417.695 342.438ZM417.677 337.452C416.093 337.452 414.779 336.228 414.779 334.176V334.032C414.779 332.052 415.895 330.666 417.767 330.666C419.603 330.666 420.755 331.89 420.755 333.996V334.122C420.755 336.228 419.423 337.452 417.677 337.452Z",
      fill: active ? colors.activeTextColor : colors.defaultTextColor
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
        id: "leading-gradient",
        x1: "390",
        x2: "390",
        y1: "103.222",
        y2: "294",
        gradientUnits: "userSpaceOnUse",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          stopColor: "#EFD67E"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "1",
          stopColor: "#E25529"
        })]
      })
    })]
  });
};

/* harmony default export */ var Svg_Leading = (Leading);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/OverallResult/Svg/Visionary.tsx





var Visionary = function Visionary(_ref) {
  var active = _ref.active;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      opacity: active ? 1 : 0.7,
      d: "M474 75.0377C474 71.959 475.767 69.1535 478.543 67.8231L606.543 6.48981C611.853 3.94529 618 7.81588 618 13.7043V286C618 290.418 614.418 294 610 294H482C477.582 294 474 290.418 474 286V75.0377Z",
      fill: active ? "url(#visionary-gradient)" : colors.defaultColumnFill
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M512.339 339H514.211L518.657 326.13H517.181L513.347 337.488L509.513 326.13H507.965L512.339 339ZM520.574 339H522.068V329.586H520.574V339ZM521.294 327.624C521.834 327.624 522.284 327.174 522.284 326.634C522.284 326.094 521.834 325.644 521.294 325.644C520.754 325.644 520.304 326.094 520.304 326.634C520.304 327.174 520.754 327.624 521.294 327.624ZM528.042 339.162C530.328 339.162 531.498 338.01 531.498 336.3C531.498 334.302 530.13 333.87 528.186 333.51C526.458 333.204 525.99 332.862 525.99 332.016C525.99 331.206 526.692 330.666 527.772 330.666C528.96 330.666 529.536 331.116 529.752 332.142H531.192C530.94 330.108 529.482 329.424 527.79 329.424C526.314 329.424 524.604 330.324 524.604 332.07C524.604 333.708 525.432 334.392 527.88 334.842C529.338 335.112 530.076 335.436 530.076 336.426C530.076 337.434 529.446 337.92 528.024 337.92C526.512 337.92 525.918 337.218 525.81 336.102H524.352C524.442 338.028 525.792 339.162 528.042 339.162ZM533.811 339H535.305V329.586H533.811V339ZM534.531 327.624C535.071 327.624 535.521 327.174 535.521 326.634C535.521 326.094 535.071 325.644 534.531 325.644C533.991 325.644 533.541 326.094 533.541 326.634C533.541 327.174 533.991 327.624 534.531 327.624ZM542.287 337.92C540.379 337.92 539.209 336.516 539.209 334.374V334.23C539.209 332.07 540.397 330.666 542.287 330.666C544.159 330.666 545.365 332.07 545.365 334.248V334.374C545.365 336.498 544.177 337.92 542.287 337.92ZM542.269 339.162C544.951 339.162 546.913 337.2 546.913 334.356V334.212C546.913 331.386 544.951 329.424 542.287 329.424C539.623 329.424 537.661 331.404 537.661 334.23V334.374C537.661 337.128 539.587 339.162 542.269 339.162ZM549.226 339H550.72V333.294C550.72 331.602 551.962 330.72 553.348 330.72C554.86 330.72 555.562 331.458 555.562 333.114V339H557.056V333.222C557.056 330.486 555.688 329.424 553.744 329.424C552.196 329.424 551.152 330.198 550.72 331.08V329.586H549.226V339ZM562.342 339.162C563.728 339.162 564.574 338.694 565.276 337.812V339H566.77V332.79C566.77 330.162 565.132 329.424 563.332 329.424C561.514 329.424 559.804 330.216 559.606 332.358H561.1C561.244 331.206 561.964 330.666 563.26 330.666C564.7 330.666 565.276 331.296 565.276 332.79V333.474H563.926C561.514 333.474 559.21 334.212 559.21 336.39C559.21 338.316 560.596 339.162 562.342 339.162ZM562.486 337.974C561.172 337.974 560.704 337.362 560.704 336.39C560.704 335.004 562.09 334.536 563.98 334.536H565.276V335.706C565.276 337.164 564.07 337.974 562.486 337.974ZM569.704 339H571.198V333.834C571.198 331.512 572.404 330.918 574.294 330.828V329.424C572.602 329.478 571.792 330.216 571.198 331.278V329.586H569.704V339ZM577.406 342.276H578.918L584.12 329.586H582.59L579.98 336.336L577.1 329.586H575.498L579.188 338.028L577.406 342.276Z",
      fill: active ? colors.activeTextColor : colors.defaultTextColor
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
        id: "visionary-gradient",
        x1: "546",
        x2: "546",
        y1: ".5",
        y2: "293.5",
        gradientUnits: "userSpaceOnUse",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          stopColor: "#79CCAC"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "1",
          stopColor: "#51AD8A"
        })]
      })
    })]
  });
};

/* harmony default export */ var Svg_Visionary = (Visionary);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/OverallResult/data.ts

var data_data = [{
  slug: "getting-started",
  heading: "Getting Started",
  summary: "Your data is fragmented, slow, and untrustworthy",
  description: "Your data is fragmented, slow, and untrustworthy\n    You have minimal customer data collection in place. As a result, running analyses to provide insight into your customers and personalizing your marketing efforts is very difficult.",
  component: Svg_GettingStarted
}, {
  slug: "developing",
  heading: "Developing",
  summary: "You collect data reliably, understand it, and act on it.",
  description: "You have seen the power of customer data and the insights it can provide. You\u2019ve implemented tools to collect customer data and put that data to use, but the process breaks down when you try to build holistic customer profiles and take actions based on those profiles. As a result, you may have higher customer acquisition costs and lower customer lifetime value because of poor experiences.",
  component: Svg_Developing
}, {
  slug: "leading",
  heading: "Leading",
  summary: "Data drives your KPIs and growth strategy.",
  description: "Customer data is an important part of your strategy and you can consistently answer questions about your customers. However, you may not have fully operationalized your customer data in a way that enables you to deliver personalized and timely content.",
  component: Svg_Leading
}, {
  slug: "visionary",
  heading: "Visionary",
  summary: "You lead your category with data-driven user experiences.",
  description: "You differentiate based on your user experience. Customers consistently turn to you because you provide a personalized experience, useful experience. You can easily use your customer data in the tools you need to run your business, which makes your company extremely adaptable to change.",
  component: Svg_Visionary
}];
/* harmony default export */ var OverallResult_data = (data_data);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/OverallResult/ScoreChart.tsx



var colors = {
  dashColor: "#AEB2C1",
  defaultTextColor: "#606B85",
  activeTextColor: "#394762",
  defaultColumnFill: "#E1E3EA"
};

var ScoreChart = function ScoreChart(_ref) {
  var score = _ref.score;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
    viewBox: "0 0 641 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [OverallResult_data.map(function (_ref2, index) {
      var slug = _ref2.slug,
          Component = _ref2.component;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, {
        active: index === score
      }, slug);
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M1 1H617.5",
      stroke: colors.dashColor,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "4 8"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M1 75H461.5",
      stroke: colors.dashColor,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "4 8"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M1 149H306.5",
      stroke: colors.dashColor,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "4 8"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M1 222H149.5",
      stroke: colors.dashColor,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "4 8"
    })]
  });
};

/* harmony default export */ var OverallResult_ScoreChart = (ScoreChart);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/OverallResult/OverallResult.tsx


function OverallResult_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var OverallResult_copy = {
  overline: "Your score"
};

var OverallResult = function OverallResult(_ref) {
  var rating = _ref.rating;
  var score = (0,react.useMemo)(function () {
    return OverallResult_data.filter(function (item) {
      return item.slug === rating;
    })[0];
  }, [rating]);
  var index = (0,react.useMemo)(function () {
    return OverallResult_data.findIndex(function (item) {
      return item.slug === rating;
    });
  }, [rating]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OverallResult_StyledSection, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          children: OverallResult_copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h1",
          children: score.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopySummary, {
          children: score.summary
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: score.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverallResult_ScoreChart, {
        score: index
      })
    })]
  });
};

var OverallResult_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ev30lbm1"
} : 0)(Section/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{grid-template-areas:'contents' 'copy';}}" + ( true ? "" : 0));

var CopySummary = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "ev30lbm0"
} : 0)( true ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : 0);

/* harmony default export */ var OverallResult_OverallResult = (OverallResult);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/HeroResult/HeroResult.tsx





var HeroResult_copy = {
  heading: "Thank you for completing the Customer Data Maturity evaluation",
  description: "We\u2019ve sent a copy of the results below to your email."
};

var HeroResult = function HeroResult() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroResult_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroResult_HeroComponent, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h4",
            tag: "h1",
            children: HeroResult_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pMedium",
            children: HeroResult_copy.description
          })]
        })
      })
    })
  });
};

var HeroResult_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "eimdh8v1"
} : 0)( true ? "" : 0);

var HeroResult_HeroComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "eimdh8v0"
} : 0)(recipes_Hero/* Wrapper */.im, "{gap:0;padding-bottom:20px;}" + ( true ? "" : 0));

/* harmony default export */ var HeroResult_HeroResult = (HeroResult);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/ScoreMeter/ScoreMeter.views.ts


function ScoreMeter_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var OFFSET = 15;
var RADIUS = 140;
var ScoreMeter_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e119mtq18"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
var Meter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("svg",  true ? {
  target: "e119mtq17"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e119mtq16"
} : 0)( true ? {
  name: "12xe351",
  styles: "width:100%;text-align:center;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%)"
} : 0);
var Slice = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("circle",  true ? {
  target: "e119mtq15"
} : 0)("stroke:", function (_ref) {
  var active = _ref.active,
      theme = _ref.theme;
  return active ? theme.palette.brand.darkAcai[500] : transparentize(0.9, theme.palette.brand.darkAcai[700]);
}, ";stroke-width:10px;fill:none;stroke-linecap:round;stroke-dasharray:", function (_ref2) {
  var numberOfLevels = _ref2.numberOfLevels,
      level = _ref2.level;
  return "".concat(Math.PI * RADIUS / numberOfLevels - OFFSET, ", ").concat(Math.PI * RADIUS + (Math.PI * RADIUS / numberOfLevels + OFFSET / numberOfLevels) * level);
}, ";stroke-dashoffset:", function (_ref3) {
  var numberOfLevels = _ref3.numberOfLevels;
  return Math.PI * RADIUS / numberOfLevels - OFFSET;
}, ";" + ( true ? "" : 0))));
var Mask = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("mask",  true ? {
  target: "e119mtq14"
} : 0)( true ? {
  name: "11tuy8c",
  styles: "mask-type:alpha;width:100%;height:50%"
} : 0);
var Group = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("g",  true ? {
  target: "e119mtq13"
} : 0)( true ? {
  name: "1pcnmgp",
  styles: "transform:translate(115px, 115px)"
} : 0);
var Gradient = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("rect",  true ? {
  target: "e119mtq12"
} : 0)("width:", function (_ref4) {
  var activeLevel = _ref4.activeLevel,
      numberOfLevels = _ref4.numberOfLevels;
  return "calc(".concat(activeLevel / numberOfLevels * 100, "% + ").concat(OFFSET * 2, "px)");
}, ";height:100%;" + ( true ? "" : 0))));
var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e119mtq11"
} : 0)( true ? {
  name: "avpsk8",
  styles: "margin-bottom:15px"
} : 0);
var Rating = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e119mtq10"
} : 0)( true ? {
  name: "1iww49o",
  styles: "margin:0;font-weight:600"
} : 0);
// EXTERNAL MODULE: ../../libs/matcha/recipes/ScoreMeter/assets/ScoreMeter0@2x.png
var ScoreMeter0_2x = __webpack_require__(46780);
var ScoreMeter0_2x_default = /*#__PURE__*/__webpack_require__.n(ScoreMeter0_2x);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/ScoreMeter/assets/ScoreMeter0.webp
/* harmony default export */ var ScoreMeter0 = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ../../libs/matcha/recipes/ScoreMeter/assets/ScoreMeter0@2x.webp
/* harmony default export */ var assets_ScoreMeter0_2x = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ../../libs/matcha/recipes/ScoreMeter/assets/ScoreMeter2@2x.png
var ScoreMeter2_2x = __webpack_require__(17748);
var ScoreMeter2_2x_default = /*#__PURE__*/__webpack_require__.n(ScoreMeter2_2x);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/ScoreMeter/assets/ScoreMeter2.webp
/* harmony default export */ var ScoreMeter2 = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ../../libs/matcha/recipes/ScoreMeter/assets/ScoreMeter2@2x.webp
var assets_ScoreMeter2_2x = __webpack_require__(18725);
var assets_ScoreMeter2_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ScoreMeter2_2x);
// EXTERNAL MODULE: ../../libs/matcha/recipes/ScoreMeter/assets/ScoreMeter3@2x.png
var ScoreMeter3_2x = __webpack_require__(66719);
var ScoreMeter3_2x_default = /*#__PURE__*/__webpack_require__.n(ScoreMeter3_2x);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/ScoreMeter/assets/ScoreMeter3.webp
/* harmony default export */ var ScoreMeter3 = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ../../libs/matcha/recipes/ScoreMeter/assets/ScoreMeter3@2x.webp
var assets_ScoreMeter3_2x = __webpack_require__(37105);
var assets_ScoreMeter3_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ScoreMeter3_2x);
// EXTERNAL MODULE: ../../libs/matcha/recipes/ScoreMeter/assets/ScoreMeter4@2x.png
var ScoreMeter4_2x = __webpack_require__(76647);
var ScoreMeter4_2x_default = /*#__PURE__*/__webpack_require__.n(ScoreMeter4_2x);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/ScoreMeter/assets/ScoreMeter4.webp
/* harmony default export */ var ScoreMeter4 = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ../../libs/matcha/recipes/ScoreMeter/assets/ScoreMeter4@2x.webp
/* harmony default export */ var assets_ScoreMeter4_2x = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ../../libs/matcha/recipes/ScoreMeter/ScoreMeter.tsx

















var NUMBER_OF_LEVELS = 4;

var getActiveLevelSrc = function getActiveLevelSrc(activeLevel) {
  var src2 = "";
  var webp = "";
  var webp2 = "";

  switch (activeLevel) {
    case 0:
      src2 = (ScoreMeter0_2x_default());
      webp = ScoreMeter0;
      webp2 = assets_ScoreMeter0_2x;
      break;

    case 2:
      src2 = (ScoreMeter2_2x_default());
      webp = ScoreMeter2;
      webp2 = (assets_ScoreMeter2_2x_default());
      break;

    case 3:
      src2 = (ScoreMeter3_2x_default());
      webp = ScoreMeter3;
      webp2 = (assets_ScoreMeter3_2x_default());
      break;

    case 4:
      src2 = (ScoreMeter4_2x_default());
      webp = ScoreMeter4;
      webp2 = assets_ScoreMeter4_2x;
      break;

    default:
      src2 = (ScoreMeter0_2x_default());
      webp = ScoreMeter0;
      webp2 = assets_ScoreMeter0_2x;
  }

  return {
    src2: src2,
    webp: webp,
    webp2: webp2
  };
};

var ScoreMeter = function ScoreMeter(_ref) {
  var title = _ref.title,
      rating = _ref.rating,
      score = _ref.score,
      maxScore = _ref.maxScore;
  var scorePercentage = score / maxScore;
  var activeLevel = score === 0 ? 0 : Math.max(Math.ceil(scorePercentage * NUMBER_OF_LEVELS), 1);
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _getActiveLevelSrc = getActiveLevelSrc(activeLevel),
      src2 = _getActiveLevelSrc.src2,
      webp = _getActiveLevelSrc.webp,
      webp2 = _getActiveLevelSrc.webp2;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ScoreMeter_views_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
        variant: "h5",
        tag: "p",
        tokens: {
          color: theme.palette.brand.segmentGreen[500]
        },
        children: title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Rating, {
        variant: "pLarge",
        tag: "p",
        children: rating
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat(webp, ", ").concat(webp2, " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: "641",
        height: "555",
        src: src2,
        alt: "Score meter",
        loading: "lazy"
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/ScoreMeter/index.ts

;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/Results/ResultCard.tsx


function ResultCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var ResultCard = function ResultCard(_ref) {
  var score = _ref.score,
      title = _ref.title,
      rating = _ref.rating,
      summary = _ref.summary,
      list = _ref.list;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScoreMeter, {
      score: score,
      title: title,
      rating: rating,
      maxScore: 3
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
      variant: "pSmall",
      tokens: {
        color: theme.palette.twilio.gray[100]
      },
      children: summary
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
      variant: "h5",
      tokens: {
        color: theme.palette.twilio.gray[100]
      },
      children: "Recommendations"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
      children: list.map(function (item) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
            variant: "pSmall",
            tokens: {
              color: theme.palette.twilio.gray[100]
            },
            children: item
          })
        }, item);
      })
    })]
  });
};

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "edwuggk1"
} : 0)( true ? {
  name: "n9frdv",
  styles: "padding-left:30px"
} : 0);

var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "edwuggk0"
} : 0)( true ? {
  name: "45bbqm",
  styles: "margin:10px 0"
} : 0);

/* harmony default export */ var Results_ResultCard = (ResultCard);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/Results/data.ts
var Results_data_data = {
  collect: {
    title: "Collect",
    levels: [{
      title: "Getting Started",
      summary: "Your data collection is fragmented and inconsistent.",
      recommendations: ["Set a strategy that aligns data collection across sources", "Use a CDP to enforce, validate, and expand your strategy"]
    }, {
      title: "Developing",
      summary: "Your data collection is fragmented and lacks consistency across channels.",
      recommendations: ["Reconcile your data sources", "Use a CDP to enforce, validate, and expand your strategy"]
    }, {
      title: "Leading",
      summary: "Your data collection is nearly complete, and you have implemented some safeguards to protect data quality.",
      recommendations: ["Validate the scalability of standardized data collection across new teams, apps, and sources", "Use a CDP to enforce, validate, and expand your strategy"]
    }, {
      title: "Visionary",
      summary: "Your data collection is complete and consistent. You collect data from all key channels, and you have implemented safeguards to ensure consistent and accurate collection.",
      recommendations: ["Improve data literacy across the org by making data universally available and understandable", "Build a data council to generate more data champions"]
    }]
  },
  synthesize: {
    title: "Synthesize",
    levels: [{
      title: "Getting Started",
      summary: "You are unable to synthesize your data into customer profiles or meaningful insights for your business.",
      recommendations: ["Develop a strategy to establish unique customer identifiers", "Begin resolving those identifiers across channels", "Leverage a tool to build unified customer profiles"]
    }, {
      title: "Developing",
      summary: "You have been able to unify some customer data into profiles and are generating sporadic insights to drive your business forward.",
      recommendations: ["Build holistic, unified customer profiles", "Leverage a tool to help you complete your customer profiles"]
    }, {
      title: "Leading",
      summary: "You have most of your data unified into customer profiles and you\u2019re able to use those profiles to drive business insights.",
      recommendations: ["Perform a gap analysis on customer profiles", "Merge customer profiles with other databases you own"]
    }, {
      title: "Visionary",
      summary: "You are able to harness all customer data, unify it into customer profiles, and use those profiles to power actionable insights for your business.",
      recommendations: ["Educate your organization on the benefits of comprehensive customer profiles", "Explore how to maximize usage of predictive analytics"]
    }]
  },
  act: {
    title: "Act",
    levels: [{
      title: "Getting Started",
      summary: "You are unable to take action on your customer data.",
      recommendations: ["Leverage a CDP capable of generating and updating real-time audiences in your tools"]
    }, {
      title: "Developing",
      summary: "You can only take action on a sub-set of your customer data and personalization is inconsistent.",
      recommendations: ["Strategize and activate use cases for making the most of your CDP"]
    }, {
      title: "Leading",
      summary: "You are able to take advanced actions on your customer data and are typically able to deliver personalized experiences.\n        ",
      recommendations: ["Measure and optimize your ROI and ROAS through attribution tools", "Implement real-time suppression and inclusion audiences to improve advertising efficiency"]
    }, {
      title: "Visionary",
      summary: "You\u2019ve harnessed your data in a way that allows you to take very sophisticated action on your customer data and deliver extremely personalized experiences.",
      recommendations: ["Educate both your company and category on best practices for data-driven customer experiences"]
    }]
  },
  adapt: {
    title: "Adapt",
    levels: [{
      title: "Getting Started",
      summary: "You are largely unable to adapt to new technology or data needs for your business.",
      recommendations: ["Leverage a CDP with pre-built tool integrations"]
    }, {
      title: "Developing",
      summary: "You are able to adapt to new technology or data needs for your business, but it requiressignificant effort.",
      recommendations: ["Leverage a CDP with pre-built tool integrations", "Audit and update the efficacy of the instrumentation surrounding your CDP"]
    }, {
      title: "Leading",
      summary: "You can easily activate new tools, platforms, and user dimensions/events to your customer data.",
      recommendations: ["Optimize every team\u2019s usage of your CDP", "Ensure all use cases are being addressed"]
    }, {
      title: "Visionary",
      summary: "You are set up to adapt your business, if needed. You can quickly and easily activate new tools and platforms, and are leading your industry in the usage of those tools.",
      recommendations: ["Educate both your company and category on best practices for data-driven customer experiences"]
    }]
  }
};
/* harmony default export */ var Results_data = (Results_data_data);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/Results/Results.tsx


function Results_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var Results = function Results(_ref) {
  var collectScore = _ref.collectScore,
      synthesizeScore = _ref.synthesizeScore,
      actScore = _ref.actScore,
      adaptScore = _ref.adaptScore;
  var collect = Results_data.collect,
      synthesize = Results_data.synthesize,
      act = Results_data.act,
      adapt = Results_data.adapt;
  var collectInfo = collect.levels[collectScore];
  var synthesizeInfo = synthesize.levels[synthesizeScore];
  var actInfo = act.levels[actScore];
  var adaptInfo = adapt.levels[adaptScore];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Results_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Results_StyledSection, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid, {
          columns: 1,
          overrides: {
            md: 2,
            xl: 4
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Results_ResultCard, {
            score: collectScore,
            title: collect.title,
            rating: collectInfo.title,
            summary: collectInfo.summary,
            list: collectInfo.recommendations
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Results_ResultCard, {
            score: synthesizeScore,
            title: synthesize.title,
            rating: synthesizeInfo.title,
            summary: synthesizeInfo.summary,
            list: synthesizeInfo.recommendations
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Results_ResultCard, {
            score: actScore,
            title: act.title,
            rating: actInfo.title,
            summary: actInfo.summary,
            list: actInfo.recommendations
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Results_ResultCard, {
            score: adaptScore,
            title: adapt.title,
            rating: adaptInfo.title,
            summary: adaptInfo.summary,
            list: adaptInfo.recommendations
          })]
        })
      })
    })
  });
};

var Results_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1r4fpw2"
} : 0)( true ? "" : 0);

var Results_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1r4fpw1"
} : 0)(Section/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

var Grid = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1r4fpw0"
} : 0)( true ? {
  name: "1fb0u1x",
  styles: "gap:40px"
} : 0);

/* harmony default export */ var Results_Results = (Results);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/Quiz/schema.ts


var quizSchema = lib.z.object({
  answers: lib.z.array(lib.z.string().regex(/[a-f]/)).length(Quiz_data.length)
});
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/components/Quiz/useQuizForm.ts





var useQuizForm = function useQuizForm() {
  return (0,index_esm/* useForm */.cI)({
    resolver: (0,zod/* zodResolver */.F)(quizSchema),
    mode: "onChange",
    defaultValues: {
      answers: Quiz_data.map(function () {
        return "";
      })
    }
  });
};

/* harmony default export */ var Quiz_useQuizForm = (useQuizForm);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityEvaluation/assets/OgImage.jpg
var OgImage = __webpack_require__(17505);
var OgImage_default = /*#__PURE__*/__webpack_require__.n(OgImage);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityEvaluation/CustomerDataMaturityEvaluation.tsx




















var CustomerDataMaturityEvaluation_copy = {
  pageTitle: "Customer Data Maturity Model. Evaluate your data today! | Twilio Segment",
  pageDescription: "Evaluate your company\u2019s data strategy and we\u2019ll give you actionable and personalized recommendations on how to improve with Twilio Segment\u2019s Customer Data Maturity Model."
};

var CustomerDataMaturityEvaluationView = function CustomerDataMaturityEvaluationView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var quizForm = Quiz_useQuizForm();

  var _useState = (0,react.useState)(),
      results = _useState[0],
      setResults = _useState[1];

  var router = (0,next_router.useRouter)();
  var handleSubmit = quizForm.handleSubmit,
      formState = quizForm.formState,
      getValues = quizForm.getValues;
  var isValid = formState.isValid,
      isSubmitSuccessful = formState.isSubmitSuccessful;

  var submitHandler = function submitHandler(result) {
    return handleSubmit(function () {
      router.push("#results");
      setResults(result);
    })();
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: CustomerDataMaturityEvaluation_copy.pageTitle,
      pageDescription: CustomerDataMaturityEvaluation_copy.pageDescription,
      pageOG: (OgImage_default()),
      bodyBackground: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Main, {
        id: "results",
        children: isSubmitSuccessful && results ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroResult_HeroResult, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverallResult_OverallResult, {
            rating: results.rating
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Results_Results, {
            collectScore: results.collect.score,
            synthesizeScore: results.synthesize.score,
            actScore: results.act.score,
            adaptScore: results.adapt.score
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Quiz_Quiz, {
            form: quizForm
          }), isValid && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CalculateResults_CalculateResults, {
            answers: getValues().answers,
            onSubmit: submitHandler
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e6ozg0s0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var CustomerDataMaturityEvaluation_CustomerDataMaturityEvaluation = (CustomerDataMaturityEvaluationView);
;// CONCATENATED MODULE: ./src/pages/customer-data-maturity-evaluation/index.tsx



var CustomerDataMaturityEvaluation = function CustomerDataMaturityEvaluation() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerDataMaturityEvaluation_CustomerDataMaturityEvaluation, {});
};

/* harmony default export */ var customer_data_maturity_evaluation = (CustomerDataMaturityEvaluation);

/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 62312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-data-maturity-evaluation",
      function () {
        return __webpack_require__(21973);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17505:
/***/ (function(module) {

module.exports = "/_next/static/images/OgImage-821b7f6403ebd2cbccf5382a86f7f4f0.jpg";

/***/ }),

/***/ 46780:
/***/ (function(module) {

module.exports = "/_next/static/images/ScoreMeter0@2x-b02b55469dd709a142a86e4e66d190cb.png";

/***/ }),

/***/ 17748:
/***/ (function(module) {

module.exports = "/_next/static/images/ScoreMeter2@2x-722457e8366bf00855b59b1b2e2af7f2.png";

/***/ }),

/***/ 66719:
/***/ (function(module) {

module.exports = "/_next/static/images/ScoreMeter3@2x-3f591cecba5bfd12ed9eb7aa321e9b93.png";

/***/ }),

/***/ 76647:
/***/ (function(module) {

module.exports = "/_next/static/images/ScoreMeter4@2x-b0f625cc639b1cfeac0b720c51b7c9b1.png";

/***/ }),

/***/ 18725:
/***/ (function(module) {

module.exports = "/_next/static/images/ScoreMeter2@2x-72b5ea0b2fca7397eb4d3ab58a5e13c4.webp";

/***/ }),

/***/ 37105:
/***/ (function(module) {

module.exports = "/_next/static/images/ScoreMeter3@2x-8de9effcfca29e53985d06d64a8683a5.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,1382,4136,2073,8392,5735,2429,7303,948,8187,3996,7947,7960,6012,442,5471,9774,2888,179], function() { return __webpack_exec__(62312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);